<template>
  <div class="col-md-3 col-sm-6 col-xs-12">
        <div class="info-box animated zoomIn">
          <span :class="['info-box-icon',colorIcon]"><i :class="icon"></i></span>
          <div class="info-box-content">
            <span class="info-box-text">
                <slot name="text">
                </slot>
            </span>
            <span class="info-box-number">
                <slot name="info">
                </slot>
            </span>
          </div>
          <!-- /.info-box-content -->
        </div>
        <!-- /.info-box -->
      </div>
</template>
<script>
export default {
  name: 'InfoBox',
  props: ['icon','colorIcon']
}
</script>
<style>
.info-box {
  cursor: pointer;
}
.info-box-content {
  text-align: center;
  vertical-align: middle;
  display: inherit;
}
</style>



// WEBPACK FOOTER //
// InfoBox.vue?f6637ac2